import React, { useEffect, useRef, useState } from 'react';
import API_BASE_URL from "../../apiConfig";
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './../../assets/css/materialdesignicons.css';

const RetailersTransactionReport = () => {
  const tableRef = useRef(null);
  const [transactions, setTransactions] = useState([]);

  useEffect(() => {
    fetchTransactions();
  }, []);

  const fetchTransactions = async () => {
    try {
      const authToken = localStorage.getItem("authToken"); //  token

      const response = await fetch(`${API_BASE_URL}/PayUPayment/gettransactions`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${authToken}`,   // 👈 required for [Authorize]
          "Content-Type": "application/json"
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      // Add SrNo property to each record
      const updatedData = data.map((record, index) => ({
        ...record,
        SrNo: index + 1
      }));

      setTransactions(updatedData);
    } catch (error) {
      console.error("Error fetching transactions:", error);
    }
  };

  const handleRefund = async (transactionId) => {
    if (!window.confirm('Are you sure you want to refund this transaction?')) {
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/PayUPayment/refund/${transactionId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      });

      if (response.ok) {
        alert('Refund processed successfully.');
        fetchTransactions(); // Refresh the table after refund
      } else {
        alert('Failed to process refund.');
      }
    } catch (error) {
      console.error('Error processing refund:', error);
      alert('Error processing refund.');
    }
  };

  useEffect(() => {
    if (transactions.length > 0 && tableRef.current) {
      const table = $(tableRef.current).DataTable({
        //order: [[1, 'desc']],
        data: transactions,
        columns: [
          { data: 'SrNo', title: 'Sr No' }, // Dynamically added field
          { data: 'transactionDate', title: 'Trans Date' },
          { data: 'payUTransactionId', title: 'PayU Trans ID' },
          { data: 'transactionType', title: 'Trans Type' },
          { data: 'registrationNo', title: 'Registration No' },
          { data: 'productInfo', title: 'Product Info' },
          { data: 'amount', title: 'Amount' },
          { data: 'status', title: 'Status' },
          { data: 'name', title: 'User Name' }, // Fetching user details via reference
          { data: 'email', title: 'User Email' },
          { data: 'number', title: 'User Phone' },
          {
            data: null,
            title: 'Actions',
            render: function (data, type, row) {
              if (row.transactionType === "Debit" && row.status === "Success") {
                return `<button class="btn btn-danger btn-sm refund-btn" data-id="${row.transactionId}">Wallet Refund</button>`;
              }
              return ''; // Don't show refund button for credit transactions
            }
          },
        ],
        destroy: true, // Ensures table is reloaded properly
      });

      // ✅ Fix: Use event delegation to ensure the button click is handled
      $('#transactionsTable tbody').off('click').on('click', '.refund-btn', function () {
        const transactionId = $(this).data('id');
        handleRefund(transactionId);
      });

      return () => {
        table.destroy();
      };
    }
  }, [transactions]);

  return (
    <>
      <table ref={tableRef} id="transactionsTable" className="table table-bordered table-hover" style={{ width: '100%' }}>
        <thead>
          <tr>
            <th>Sr No</th>
            <th>Transaction Date</th>
            <th>PayU Transaction ID</th>
            <th>Transaction Type</th>
            <th>Registration No</th>
            <th>Product Info</th>
            <th>Amount</th>
            <th>Status</th>
            <th>User Name</th>
            <th>User Email</th>
            <th>User Phone</th>
            <th>Actions</th>
          </tr>
        </thead>
      </table>
    </>
  );
};


export default RetailersTransactionReport;